var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { theme, Button, Typography } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { SpaceScheduleConfiguration } from '../../../generated/graphql';
/**
 * Hook for space card UI utilities including actions and schedule configuration text.
 */
export var useSpaceCardUI = function (_a) {
    var onAddSpace = _a.onAddSpace;
    var t = useTranslation('spaceBooking').t;
    var token = theme.useToken().token;
    var _b = __read(useState(null), 2), pendingSpaceId = _b[0], setPendingSpaceId = _b[1];
    var getSpaceScheduleConfigurationText = function (scheduleConfiguration) {
        switch (scheduleConfiguration) {
            case SpaceScheduleConfiguration.OnDemand:
                return (_jsx(_Fragment, { children: _jsx(Typography.Text, { type: "secondary", children: t('on_demand') }) }));
            case SpaceScheduleConfiguration.RequestOnly:
                return (_jsxs(_Fragment, { children: [_jsx(FontAwesomeIcon, { icon: faLock, color: token.colorTextSecondary }), ' ', _jsx(Typography.Text, { type: "secondary", children: t('request_only') })] }));
            case SpaceScheduleConfiguration.Scheduled:
                return null;
        }
    };
    var cardActions = function (space, spaceIsBookable) {
        var isRequestOnly = space.scheduleConfiguration === SpaceScheduleConfiguration.RequestOnly;
        return [
            spaceIsBookable && (_jsx(Button, { style: {
                    width: '100%',
                }, disabled: pendingSpaceId !== null, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var spaceId;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                spaceId = space.id;
                                // Check if another space is already pending
                                if (pendingSpaceId !== null) {
                                    return [2 /*return*/];
                                }
                                setPendingSpaceId(spaceId);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, , 3, 4]);
                                return [4 /*yield*/, onAddSpace(spaceId)];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                setPendingSpaceId(null);
                                return [7 /*endfinally*/];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, loading: pendingSpaceId === space.id, children: isRequestOnly ? t('request') : t('add_to_event') }, space.id)),
        ].filter(Boolean);
    };
    return { cardActions: cardActions, getSpaceScheduleConfigurationText: getSpaceScheduleConfigurationText, pendingSpaceId: pendingSpaceId };
};
